import ACCOUNT_ROUTES from '../../../constants/account-routes';
import BreadcrumbLink from '../breadcrumb-link';
import useTranslation from '@blueshift-ui/i18n/dist/hooks/use-translation';

function BackToPlanButton() {
  const { translate } = useTranslation('membership');

  return (
    <BreadcrumbLink id="back_to_plan_button" to={`/${ACCOUNT_ROUTES.membership}`}>
      {translate('back_to_plan_cta', '')}
    </BreadcrumbLink>
  );
}

export default BackToPlanButton;
